"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const input_1 = __importDefault(require("../input"));
const icon_1 = __importDefault(require("../icon"));
const index_1 = require("../../index");
const { ArrowDown } = icon_1.default;
const StyledDiv = styled_components_1.default.div `
  position: relative;
  cursor: pointer;
  flex-grow: ${({ flexGrow }) => flexGrow};
  width: ${({ width = "auto" }) => {
    return width;
}};
`;
const StyledButton = styled_components_1.default.button `
  font-size: 14px;
  appearance: none;
  background: ${({ isDisabled, theme }) => isDisabled ? theme.neutral.lighter : theme.white};
  border-radius: 4px;
  border: ${({ isError, isSuccess, isDisabled, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isSuccess
                ? theme.success.main
                : theme.neutral.main;
    return `1px solid ${color}`;
}};
  color: ${({ isDisabled, theme }) => isDisabled ? theme.text.secondary : theme.text.primary};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  font-weight: 400;
  padding: 0 35px 0 12px;
  text-align: left;
  position: relative;
  overflow: hidden;
  outline: none;
  text-overflow: ellipsis;
  min-width: 90px;
  height: 32px;
  white-space: nowrap;
  width: 100%;
  &::after {
    content: "";
    border-radius: 1px;
    border-style: solid;
    border-color: transparent;
    border-top-color: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.coolGrey};
    border-left-color: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.coolGrey};
    border-width: 1px;
    padding: 2px;
    position: absolute;
    right: 12px;
    transition: all 0.3s ease-in-out;
    top: ${({ isIconRotate }) => isIconRotate ? "calc(45% + 1px)" : "calc(35% + 1px)"};
    transform: ${({ isIconRotate }) => isIconRotate ? "rotate(45deg)" : "rotate(-135deg)"};
  }
  &.active::after {
    border-color: transparent;
    border-bottom-color: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.lightGrey};
    top: calc(50% - 3px);
  }
  &:focus {
    border-color: ${({ theme }) => theme.primary.main}
    outline: none;
  }
  &::placeholder {
    color: ${({ theme }) => theme.neutral.light};
  }
`;
const StyledUl = styled_components_1.default.ul `
  background: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.white};
  box-shadow: 0px 2px 4px rgba(153, 153, 153, 0.25);
  box-sizing: border-box;
  border-radius: 5px;
  font-family: "Gotham", "Gotham B", "Open Sans", sans-serif;
  font-size: 14px;
  left: 0;
  list-style: none;
  margin: 0;
  max-height: 0;
  overflow: auto;
  position: absolute;
  padding: 5px;
  transition: max-height 0.3s linear;
  visibility: hidden;
  width: 100%;
  z-index: 10;
  &[aria-expanded="true"] {
    visibility: visible;
    max-height: 300px;
  }
  & > li {
    align-items: center;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 12px 10px 12px;
    margin: 5px 0;
    white-space: nowrap;
  }
  & > li:hover,
  & > li:focus {
    background: ${({ theme }) => theme.neutral.main};
    border-radius: 5px;
    color: ${({ theme }) => theme.text.primary};
    font-weight: 400;
    outline: none;
  }
  & span {
    color: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.white};
    border-radius: 3px;
    background-color: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.lightGrey};
    left: 1%;
    max-width: 85%;
    min-height: 20px;
    margin-top: 2px;
    position: absolute;
    padding: 5px;
    visibility: hidden;
  }
  & li:hover + span {
    visibility: visible;
  }
`;
const Label = styled_components_1.default.label `
  color: ${({ theme }) => theme.text.secondary};
  font-size: 14px;
  font-weight: 400;
  ${({ isLabelTop }) => isLabelTop
    ? (0, styled_components_1.css) `
          margin-bottom: 4px;
        `
    : (0, styled_components_1.css) `
          margin-right: 16px;
          white-space: nowrap;
        `}
`;
const ErrorMessage = styled_components_1.default.p `
  margin-top: 4px;
  margin-bottom: 0;
  position: absolute;
  font-weight: normal;
  font-style: italic;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.error.main};
`;
const InputWithLabelWrapper = styled_components_1.default.div `
  margin: 16px 0;
  display: flex;
  ${({ isLabelTop }) => isLabelTop
    ? (0, styled_components_1.css) `
          flex-direction: column;
        `
    : (0, styled_components_1.css) `
          align-items: center;
        `}
`;
const StyledInput = (0, styled_components_1.default)(input_1.default).attrs({
    style: { fontSize: "14px" },
    wrapperStyles: { margin: 0 }
}) `
  color: ${({ isDisabled, theme }) => isDisabled ? theme.text.secondary : theme.text.primary};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
`;
const StyledArrow = (0, styled_components_1.default)(ArrowDown) `
  width: 8px;
  color: ${index_1.colors === null || index_1.colors === void 0 ? void 0 : index_1.colors.coolGrey};
  transition: all 0.3s ease-in-out;
  transform: ${({ isIconRotate }) => isIconRotate ? "rotate(180deg)" : "rotate(0deg)"};
`;
const StyledEmptyState = styled_components_1.default.p `
  color: ${({ theme }) => theme.neutral.main};
  text-align: center;
`;
const RotaDropdown = ({ options, onChange, value, placeholder, flexGrow = 1, width, errorMessage, label, isLabelTop = false, id, isError = false, isSuccess = false, isDisabled = false, isFocused = false, isSearchable = false, onSearchText, isLoading = false, onLoadMore, isDisplayValueDisabled = false }) => {
    const [isDropdownOpen, setIsDropdownOpen] = (0, react_1.useState)(false);
    const [displayValue, setDisplayValue] = (0, react_1.useState)();
    const [dropdownOptions, setDropdownOptions] = (0, react_1.useState)([]);
    const selectNode = (0, react_1.useRef)(null);
    const dropdownOptionsRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (options)
            setDropdownOptions(options);
    }, [options]);
    (0, react_1.useEffect)(() => {
        var _a;
        const objType = options === null || options === void 0 ? void 0 : options.map(el => typeof el == "object");
        if (objType) {
            return setDisplayValue(value === undefined
                ? placeholder
                : (_a = options === null || options === void 0 ? void 0 : options.find(el => el.value == value)) === null || _a === void 0 ? void 0 : _a.label);
        }
        return setDisplayValue(value);
    }, [value]);
    (0, react_1.useEffect)(() => {
        isDropdownOpen
            ? document.addEventListener("mousedown", handleClickOutside)
            : document.removeEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isDropdownOpen]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (onLoadMore) {
            (_a = dropdownOptionsRef === null || dropdownOptionsRef === void 0 ? void 0 : dropdownOptionsRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("scroll", e => {
                const target = e.target;
                const scrollTop = target.scrollTop + target.clientHeight;
                if (scrollTop >= target.scrollHeight - 20)
                    onLoadMore();
            });
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (e) => {
        var _a;
        const currentNode = (_a = selectNode === null || selectNode === void 0 ? void 0 : selectNode.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);
        !currentNode && setIsDropdownOpen(false);
    };
    const handleInputChange = (value) => {
        if (onSearchText)
            onSearchText(value);
        setDisplayValue(value);
        setIsDropdownOpen(true);
        setDropdownOptions(options.filter(({ label }) => label.toLowerCase().includes(value.toLowerCase().trim())));
    };
    return (react_1.default.createElement(InputWithLabelWrapper, { isLabelTop: isLabelTop },
        label && (react_1.default.createElement(Label, { htmlFor: id, isLabelTop: isLabelTop }, label)),
        react_1.default.createElement(StyledDiv, { ref: selectNode, width: width, flexGrow: flexGrow },
            isSearchable ? (react_1.default.createElement(StyledInput, { value: displayValue !== null && displayValue !== void 0 ? displayValue : "", placeholder: placeholder, onClick: () => setIsDropdownOpen(!isDropdownOpen), onChange: e => handleInputChange(e.target.value), isError: isError, isSuccess: isSuccess, isDisabled: isDisabled, iconRight: react_1.default.createElement(StyledArrow, { isIconRotate: isDropdownOpen }) })) : (react_1.default.createElement(StyledButton, { "aria-haspopup": "true", onClick: () => setIsDropdownOpen(!isDropdownOpen), placeholder: placeholder, isIconRotate: isDropdownOpen, isError: isError, isSuccess: isSuccess, isFocused: isFocused, isDisabled: isDisabled }, (displayValue === null || displayValue === void 0 ? void 0 : displayValue.length) ? displayValue : placeholder)),
            react_1.default.createElement(StyledUl, { ref: dropdownOptionsRef, className: "dropdown-menu", role: "listbox", "aria-expanded": isDropdownOpen },
                dropdownOptions.length ? (dropdownOptions.map(item => (react_1.default.createElement("li", { key: item.value, value: item.value, tabIndex: 0, "aria-labelledby": item.label, "data-tip": true, onClick: () => {
                        setDisplayValue(isDisplayValueDisabled ? "" : item.label);
                        setIsDropdownOpen(false);
                        onChange(item.value);
                        isSearchable && setDropdownOptions(options);
                    } }, item.label || item)))) : (react_1.default.createElement(StyledEmptyState, null, "Found no results...")),
                isLoading && react_1.default.createElement("li", null, "Loading more...")),
            isError && errorMessage && react_1.default.createElement(ErrorMessage, null, errorMessage))));
};
exports.default = RotaDropdown;
